import { get } from 'lodash';
import * as React from 'react';

const Address = ({ data, type }) => {

    const block = get(data, 'attributes.block', null);
    const firstName = get(data, 'attributes.first_name', null);
    const lastName = get(data, 'attributes.last_name', null);
    const office = get(data, 'attributes.office.attributes.address', null);
    const phone = get(data, 'attributes.phone', null);
    const place = get(data, 'attributes.place.attributes.name', null);
    const region = get(data, 'attributes.region.attributes.name', null);
    const store = get(data, 'attributes.store.attributes.name', null);
    const street = get(data, 'attributes.street', null);
    const streetNumber = get(data, 'attributes.street_number', null);
    const zipcode = get(data, 'attributes.zipcode', null);
    const neighborhood = get(data, 'attributes.neighborhood', null);

    const econt = <React.Fragment>
        <p>Име: <strong>{firstName} {lastName}</strong></p>
        <p>Телефон: <strong>{phone}</strong></p>
        <p>Област: <strong>{region}</strong></p>
        <p>Град: <strong>{place}</strong></p>
        <p>Пощенски код: <strong>{zipcode}</strong></p>
        <p>Офис: <strong>{office}</strong></p>
    </React.Fragment>;

    const speedy = <React.Fragment>
        <p>Име: <strong>{firstName} {lastName}</strong></p>
        <p>Телефон: <strong>{phone}</strong></p>
        <p>Област: <strong>{region}</strong></p>
        <p>Град: <strong>{place}</strong></p>
        <p>Пощенски код: <strong>{zipcode}</strong></p>
        { neighborhood ? <p>Квартал: <strong>{neighborhood}</strong></p> : null }
        { block ? <p>Блок: <strong>{block}</strong></p> : null }
        { street ? <p>Улица: <strong>{street}</strong></p> : null }
        { streetNumber ? <p>Номер на улица: <strong>{streetNumber}</strong></p> : null }
    </React.Fragment>;

    const speedyOffice = <React.Fragment>
        <p>Име: <strong>{firstName} {lastName}</strong></p>
        <p>Телефон: <strong>{phone}</strong></p>
        <p>Област: <strong>{region}</strong></p>
        <p>Град: <strong>{place}</strong></p>
        <p>Пощенски код: <strong>{zipcode}</strong></p>
        <p>Офис: <strong>{office}</strong></p>
    </React.Fragment>;

    const onSite = <React.Fragment>
        <p>Име: <strong>{firstName} {lastName}</strong></p>
        <p>Телефон: <strong>{phone}</strong></p>
        <p>Магазин: <strong>{store}</strong></p>
    </React.Fragment>;

    let address = null;
    switch (type) {
        case 'econt':
            address = econt;
            break;
        case 'speedy':
            address = speedy;
            break;
        case 'speedy_office':
            address = speedyOffice;
            break;
        case 'on_site':
            address = onSite;
            break;    
        default:
            address = null
            break;
    }

    return (
        <div>
            <h5>Адрес</h5>
            {address} 
        </div>
    );
};

export default Address;



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersList/OrderDetails/Address.js